module.exports = __webpack_public_path__ + "static/media/UniNeueHeavy-Italic.d780ce8f.woff";